<template>
    <div class="modal-overlay" :class="{ active: show }" v-if="show">
        <div class="modal-content">
            <div class="close-btn" @click="$emit('close')">
                X
            </div>
            <h2 class="modal-title">{{ title }}</h2>

            <div class="chart-container" v-if="sjshow" id="bqs">
                <!-- <canvas ref="pieChart"></canvas> -->
            </div>
            <div class="chart-container" v-else style="text-align:center;line-height: 100px;font-size: 30px;" >
                    暂无子集
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
export default {
    data() {
        return {
            // show:false,
            // title:'',
            sjshow:true,
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
        id: {
            type: String,
            default: "",
        },
    },
    watch: {
        show(newVal) {
            if (newVal) {
                // console.log("22222");
                let that=this;
                that.$nextTick(() => {
                    // console.log(that.id,"5555");
                    if(that.id && that.id!=''){
                         that.getData();
                    }else{
                         if (window.innerWidth > 1440) {
                            // console.log("111111111");
                            that.brandTagActs('bqs', ['37%', '48%'], ['57%', '68%'], 20, ['0', '30%'], 16);
                        } else {
                            that.brandTagActs('bqs', ['27%', '38%'], ['47%', '55%'], 10, ['0', '20%'], 14);
                        }
                        
                    }
                   
                    
                });
            }
        },
    },
    mounted() {

    },
    methods: {
        getData(){
            getAction('/analysis/brandLabelInfo', {
				id:this.id
			}).then((res) => {
                if(res.code=='200'){
                    let list = [{
						label: {
							textStyle: {
								color: "#106bff",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}, {
						label: {
							textStyle: {
								color: "#00b8ff",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}, {
						label: {
							textStyle: {
								color: "#ff6262",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}, {
						label: {
							textStyle: {
								color: "#ffb81a",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}, {
						label: {
							textStyle: {
								color: "#6fef33",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}, {
						label: {
							textStyle: {
								color: "#6faf33",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}];
					let list1 = [
						{
							itemStyle: { color: 'rgba(16,108,255,0.3)' }
						},
						{
							itemStyle: { color: 'rgba(0,184,255,0.3)' }
						},
						{
							itemStyle: { color: 'rgba(255,98,98,0.3)' }
						},
						{
							itemStyle: { color: 'rgba(255,184,26,0.3)' }
						},
						{
							itemStyle: { color: 'rgba(111,239,51,0.3)' }
						},
						{
							itemStyle: { color: 'rgba(111,249,51,0.3)' }
						},
					];
					let sj = res.result.dataList;
                    let that=this;
                    console.log(sj,"22222");
                    if(sj.length>0){
                       
                        let arr = [], arr1 = [];
                        for (var i = 0; i < sj.length; i++) {
                            //					      	console.log(list[i].label);
                            arr.push({ name: sj[i].name, value: sj[i].value, label: list[i].name });
                            arr1.push({ name: sj[i].name, value: sj[i].value, });
                        }
                        that.sjshow=true;
                        that.$nextTick(() => {
                           
                            if (window.innerWidth > 1440) {
                               that.brandTagAct('bqs', ['37%', '48%'], ['57%', '68%'], 20, ['0', '30%'], 16, arr, arr1,sj);
                            } else {
                               that.brandTagAct('bqs', ['27%', '38%'], ['47%', '55%'], 10, ['0', '20%'], 14, arr, arr1,sj);
                            }
                        });
                        
                       
                    }else{
                       that.sjshow=false;
                    }
					that.$forceUpdate();
                }
				
			}); 
        },
        brandTagActs(id, arr, arr1, value, value1, value2) {
            var myChart = echarts.init(document.getElementById(id));
            let list = [
                {
                    name: "诗词文化",
                    value: 10,
                    label: {
                        textStyle: {
                            color: "#106bff",
                            fontSize: 18,
                            fontWeight: 600,
                            borderColor: "#517FD9",
                        },
                    },
                },
                {
                    name: "戏曲文化",
                    value: 12,
                    label: {
                        textStyle: {
                            color: "#00b8ff",
                            fontSize: 18,
                            fontWeight: 600,
                            borderColor: "#517FD9",
                        },
                    },
                },
                {
                    name: "音乐文化",
                    value: 33,
                    label: {
                        textStyle: {
                            color: "#ff6262",
                            fontSize: 18,
                            fontWeight: 600,
                            borderColor: "#517FD9",
                        },
                    },
                },
                // {
                //     name: "传统文化",
                //     value: 42,
                //     label: {
                //         textStyle: {
                //             color: "#ffb81a",
                //             fontSize: 18,
                //             fontWeight: 600,
                //             borderColor: "#517FD9",
                //         },
                //     },
                // },
                // {
                //     name: "其他",
                //     value: 3,
                //     label: {
                //         textStyle: {
                //             color: "#6fef33",
                //             fontSize: 18,
                //             fontWeight: 600,
                //             borderColor: "#517FD9",
                //         },
                //     },
                // },
            ];

            let list1 = [
                {
                    name: "诗词文化",
                    value: 10,
                    itemStyle: { color: 'rgba(16,108,255,0.3)' }
                },
                {
                    name: "戏曲文化",
                    value: 12,
                    itemStyle: { color: 'rgba(0,184,255,0.3)' }
                },
                {
                    name: "音乐文化",
                    value: 33,
                    itemStyle: { color: 'rgba(255,98,98,0.3)' }
                },
                // {
                //     name: "传统文化",
                //     value: 42,
                //     itemStyle: { color: 'rgba(255,184,26,0.3)' }
                // },
                // {
                //     name: "其他",
                //     value: 3,
                //     itemStyle: { color: 'rgba(111,239,51,0.3)' }
                // },
            ];
            let angle = 0;
            let option = {
                color: [
                    "#106bff",
                    "#00b8ff",
                    "#ff6262",
                    "#ffb81a",
                    "#6fef33",
                    "#106bff",
                    "#8d4bbb",
                    "#6635EF",
                    "#FFAFDA",
                ],
                tooltip: {
                    show: false,
                },
                legend: {
                    show: false,
                },
                series: [
                    {
                        name: "访问来源",
                        type: "pie",
                        selectedMode: "single",
                        center: ['50%', '50%'],
                        radius: arr,
                        label: {
                            normal: {
                                show: false,
                                position: "inner",
                                formatter: "{d}%",
                                textStyle: {
                                    color: "#fff",
                                    fontWeight: "normal",
                                    fontSize: 20,
                                },
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false,
                            },
                        },
                        itemStyle: {
                            normal: {
                                borderColor: "#001553",
                                borderWidth: 0,
                                color: "rgba(16,108,255,0.1)",
                            },
                        },
                        data: list1,
                    },
                    {
                        itemStyle: {
                            normal: {
                                borderColor: "#001553",
                                borderWidth: 4,
                            },
                        },
                        name: "访问来源",
                        type: "pie",
                        center: ['50%', '50%'],
                        radius: arr1,
                        label: {
                            normal: {
                                formatter: "{b|{d}%}\n{hr|}\n{d|{b}}",
                                rich: {
                                    b: {
                                        fontSize: value2,
                                        align: "left",
                                        padding: 4,
                                    },
                                    hr: {
                                        borderColor: "#12EABE",
                                        width: "100%",
                                        borderWidth: 2,
                                        height: 0,
                                    },
                                    d: {
                                        fontSize: value2,
                                        color: "#fff",
                                        align: "left",
                                        padding: 4,
                                    },
                                    c: {
                                        fontSize: value2,
                                        color: "#fff",
                                        align: "center",
                                        padding: 4,
                                    },
                                },
                            },
                        },
                        labelLine: {
                            normal: {
                                show: true,
                                length: value,
                                length2: value,
                                lineStyle: {
                                    type: "dashed",
                                    width: 2,
                                },
                            },
                        },
                        data: list,
                    },
                    {
                        name: "ring5",
                        type: "custom",
                        hoverAnimation: false,
                        clockwise: true,
                        coordinateSystem: "none",
                        z: 20, // 设置 markPoint 的 z-index
                        zlevel: 2, // 设置 markPoint 的 zlevel
                        renderItem: function (params, api) {
                            return {
                                type: "arc",
                                shape: {
                                    cx: api.getWidth() / 2,
                                    cy: api.getHeight() / 2,
                                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.25,
                                    startAngle: ((270 + -angle) * Math.PI) / 180,
                                    endAngle: ((40 + -angle) * Math.PI) / 180,
                                },
                                style: {
                                    shadowColor: "#4FADFD",
                                    shadowBlur: 10,
                                    stroke: "#0CD3DB",
                                    fill: "transparent",
                                    lineWidth: 1.5,
                                },
                                silent: true,
                            };
                        },
                        data: [0],
                    },
                    {
                        name: "访问来源",
                        type: "pie",
                        clockwise: true,
                        hoverAnimation: false,
                        coordinateSystem: "none",
                        radius: value1,
                        center: ['50%', '50%'],
                        data: [100],
                        itemStyle: {
                            normal: {
                                color: "#043173",
                            },
                        },
                        label: {
                            show: false,
                        },
                        labelLine: {
                            normal: {
                                show: false,
                                length: value,
                                length2: value,
                                lineStyle: {
                                    type: "dashed",
                                    width: 2,
                                },
                            },
                        },
                    },
                ],
            };
            function draw() {
                angle = angle + 3;
                myChart.setOption(option, true);
                //window.requestAnimationFrame(draw);
            }

            myChart.on("finished", function () {
                setInterval(function () {
                    //用setInterval做动画感觉有问题
                    draw();
                }, 100);
                // 在这里执行你想要在渲染完成后执行的代码
            });
            //	  	  myChart.clear();
            myChart.setOption(option);
        },
        brandTagAct(id, arr, arr1, value, value1, value2,list, list1,sj) {
            var myChart = echarts.init(document.getElementById(id));
            // let list = [
            //     {
            //         name: "诗词文化",
            //         value: 10,
            //         label: {
            //             textStyle: {
            //                 color: "#106bff",
            //                 fontSize: 18,
            //                 fontWeight: 600,
            //                 borderColor: "#517FD9",
            //             },
            //         },
            //     },
            //     {
            //         name: "戏曲文化",
            //         value: 12,
            //         label: {
            //             textStyle: {
            //                 color: "#00b8ff",
            //                 fontSize: 18,
            //                 fontWeight: 600,
            //                 borderColor: "#517FD9",
            //             },
            //         },
            //     },
            //     {
            //         name: "音乐文化",
            //         value: 33,
            //         label: {
            //             textStyle: {
            //                 color: "#ff6262",
            //                 fontSize: 18,
            //                 fontWeight: 600,
            //                 borderColor: "#517FD9",
            //             },
            //         },
            //     },
            //     // {
            //     //     name: "传统文化",
            //     //     value: 42,
            //     //     label: {
            //     //         textStyle: {
            //     //             color: "#ffb81a",
            //     //             fontSize: 18,
            //     //             fontWeight: 600,
            //     //             borderColor: "#517FD9",
            //     //         },
            //     //     },
            //     // },
            //     // {
            //     //     name: "其他",
            //     //     value: 3,
            //     //     label: {
            //     //         textStyle: {
            //     //             color: "#6fef33",
            //     //             fontSize: 18,
            //     //             fontWeight: 600,
            //     //             borderColor: "#517FD9",
            //     //         },
            //     //     },
            //     // },
            // ];

            // let list1 = [
            //     {
            //         name: "诗词文化",
            //         value: 10,
            //         itemStyle: { color: 'rgba(16,108,255,0.3)' }
            //     },
            //     {
            //         name: "戏曲文化",
            //         value: 12,
            //         itemStyle: { color: 'rgba(0,184,255,0.3)' }
            //     },
            //     {
            //         name: "音乐文化",
            //         value: 33,
            //         itemStyle: { color: 'rgba(255,98,98,0.3)' }
            //     },
            //     // {
            //     //     name: "传统文化",
            //     //     value: 42,
            //     //     itemStyle: { color: 'rgba(255,184,26,0.3)' }
            //     // },
            //     // {
            //     //     name: "其他",
            //     //     value: 3,
            //     //     itemStyle: { color: 'rgba(111,239,51,0.3)' }
            //     // },
            // ];
            let angle = 0;
            myChart.clear();
            let option = {
                color: [
                    "#106bff",
                    "#00b8ff",
                    "#ff6262",
                    "#ffb81a",
                    "#6fef33",
                    "#106bff",
                    "#8d4bbb",
                    "#6635EF",
                    "#FFAFDA",
                ],
                tooltip: {
                    show: false,
                },
                legend: {
                    show: false,
                },
                series: [
                    {
                        name: "访问来源",
                        type: "pie",
                        selectedMode: "single",
                        center: ['50%', '50%'],
                        radius: arr,
                        label: {
                            normal: {
                                show: false,
                                position: "inner",
                                formatter: "{d}%",
                                textStyle: {
                                    color: "#fff",
                                    fontWeight: "normal",
                                    fontSize: 20,
                                },
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false,
                            },
                        },
                        itemStyle: {
                            normal: {
                                borderColor: "#001553",
                                borderWidth: 0,
                                color: "rgba(16,108,255,0.1)",
                            },
                        },
                        data: list1,
                    },
                    {
                        itemStyle: {
                            normal: {
                                borderColor: "#001553",
                                borderWidth: 4,
                            },
                        },
                        name: "访问来源",
                        type: "pie",
                        center: ['50%', '50%'],
                        radius: arr1,
                        label: {
                            normal: {
                                formatter: "{b|{d}%}\n{hr|}\n{d|{b}}",
                                rich: {
                                    b: {
                                        fontSize: value2,
                                        align: "left",
                                        padding: 4,
                                    },
                                    hr: {
                                        borderColor: "#12EABE",
                                        width: "100%",
                                        borderWidth: 2,
                                        height: 0,
                                    },
                                    d: {
                                        fontSize: value2,
                                        color: "#fff",
                                        align: "left",
                                        padding: 4,
                                    },
                                    c: {
                                        fontSize: value2,
                                        color: "#fff",
                                        align: "center",
                                        padding: 4,
                                    },
                                },
                            },
                        },
                        labelLine: {
                            normal: {
                                show: true,
                                length: value,
                                length2: value,
                                lineStyle: {
                                    type: "dashed",
                                    width: 2,
                                },
                            },
                        },
                        data: list,
                    },
                    {
                        name: "ring5",
                        type: "custom",
                        hoverAnimation: false,
                        clockwise: true,
                        coordinateSystem: "none",
                        z: 20, // 设置 markPoint 的 z-index
                        zlevel: 2, // 设置 markPoint 的 zlevel
                        renderItem: function (params, api) {
                            return {
                                type: "arc",
                                shape: {
                                    cx: api.getWidth() / 2,
                                    cy: api.getHeight() / 2,
                                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.25,
                                    startAngle: ((270 + -angle) * Math.PI) / 180,
                                    endAngle: ((40 + -angle) * Math.PI) / 180,
                                },
                                style: {
                                    shadowColor: "#4FADFD",
                                    shadowBlur: 10,
                                    stroke: "#0CD3DB",
                                    fill: "transparent",
                                    lineWidth: 1.5,
                                },
                                silent: true,
                            };
                        },
                        data: [0],
                    },
                    {
                        name: "访问来源",
                        type: "pie",
                        clockwise: true,
                        hoverAnimation: false,
                        coordinateSystem: "none",
                        radius: value1,
                        center: ['50%', '50%'],
                        data: [100],
                        itemStyle: {
                            normal: {
                                color: "#043173",
                            },
                        },
                        label: {
                            show: false,
                        },
                        labelLine: {
                            normal: {
                                show: false,
                                length: value,
                                length2: value,
                                lineStyle: {
                                    type: "dashed",
                                    width: 2,
                                },
                            },
                        },
                    },
                ],
            };
            function draw() {
                angle = angle + 3;
                myChart.setOption(option, true);
                //window.requestAnimationFrame(draw);
            }

            myChart.on("finished", function () {
                setInterval(function () {
                    //用setInterval做动画感觉有问题
                    draw();
                }, 100);
                // 在这里执行你想要在渲染完成后执行的代码
            });
            //	  	  myChart.clear();
            myChart.setOption(option);
        },
    }
}
</script>
<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    opacity: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    transition: all 0.4s ease;
}

.modal-overlay.active {
    opacity: 1;
    visibility: visible;
}

.modal-content {
    background-color: #01297d;
    border-radius: 20px;
    width: 90%;
    max-width: 700px;
    padding: 0px 0px 40px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    position: relative;
    transform: scale(0.9);
    transition: transform 0.4s ease;
}

.modal-overlay.active .modal-content {
    transform: scale(1);
}

.close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    // background: #f5f5f5;
    border: none;
    border-radius: 50%;
    font-size: 20px;
    cursor: pointer;
    // color: #888;
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}



.modal-title {
    color: #02f4f5;
    margin-bottom: 25px;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    padding: 25px 0px 15px;
    // border-bottom: 2px solid #f1f1f1;
}

.chart-container {
    width: 100%;
    height: 350px;
    position: relative;
    margin: 20px 0 40px;
    padding: 0px 20px;
    box-sizing: border-box;
}
</style>